





// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { collection, addDoc, Timestamp, doc, getDoc } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig';
// import './Compare.css';

// const Compare = () => {
//   const [compareItems, setCompareItems] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [notification, setNotification] = useState({ show: false, message: '', type: '' });

//   useEffect(() => {
//     const fetchCompareItems = async () => {
//       try {
//         // Load compare items from localStorage
//         const storedItems = localStorage.getItem('compareItems');
//         if (storedItems) {
//           const parsedItems = JSON.parse(storedItems);
//           const itemsArray = Array.isArray(parsedItems) ? parsedItems : [];
          
//           // For each item in compare, fetch the complete data from Firestore
//           const enrichedItems = await Promise.all(
//             itemsArray.map(async (item) => {
//               try {
//                 // If the item already has all the technical specs, return it as is
//                 if (item.clockSpeed && item.microcontroller && item.flashMemory) {
//                   return item;
//                 }
                
//                 // Otherwise, fetch complete data from Firestore
//                 const productDoc = await getDoc(doc(db, 'products', item.id));
                
//                 if (productDoc.exists()) {
//                   const productData = productDoc.data();
//                   // Merge existing item data with Firestore data
//                   return { ...item, ...productData };
//                 }
//                 return item;
//               } catch (fetchError) {
//                 console.error(`Error fetching details for product ${item.id}:`, fetchError);
//                 return item;
//               }
//             })
//           );
          
//           setCompareItems(enrichedItems);
          
//           // Update localStorage with enriched data
//           localStorage.setItem('compareItems', JSON.stringify(enrichedItems));
//         } else {
//           setCompareItems([]);
//         }

//         // Load cart items to track which products are already in cart
//         const storedCart = localStorage.getItem('cartItems');
//         if (storedCart) {
//           const parsedCart = JSON.parse(storedCart);
//           const cartMap = {};
          
//           if (Array.isArray(parsedCart)) {
//             parsedCart.forEach(item => {
//               cartMap[item.id] = item.quantity || 0;
//             });
//           }
          
//           setCartItems(cartMap);
//         }
//       } catch (error) {
//         console.error("Error loading compare items:", error);
//         setError("Error loading comparison items. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCompareItems();

//     // Listen for cart updates
//     const handleCartUpdate = () => {
//       const storedCart = localStorage.getItem('cartItems');
//       if (storedCart) {
//         const parsedCart = JSON.parse(storedCart);
//         const cartMap = {};
        
//         if (Array.isArray(parsedCart)) {
//           parsedCart.forEach(item => {
//             cartMap[item.id] = item.quantity || 0;
//           });
//         }
        
//         setCartItems(cartMap);
//       } else {
//         setCartItems({});
//       }
//     };

//     window.addEventListener('cartUpdated', handleCartUpdate);
    
//     return () => {
//       window.removeEventListener('cartUpdated', handleCartUpdate);
//     };
//   }, []);

//   const handleRemoveItem = (productId) => {
//     try {
//       const updatedItems = compareItems.filter(item => item.id !== productId);
//       setCompareItems(updatedItems);
//       localStorage.setItem('compareItems', JSON.stringify(updatedItems));
      
//       // Dispatch event to update floating action button
//       const event = new Event('compareUpdated');
//       window.dispatchEvent(event);
//     } catch (error) {
//       console.error("Error removing item from compare:", error);
//       setError("Error removing item. Please try again.");
//     }
//   };

//   const handleAddToCart = async (product) => {
//     try {
//       // Get existing cart
//       const existingCart = localStorage.getItem('cartItems');
//       let cartArray = [];
      
//       if (existingCart) {
//         cartArray = JSON.parse(existingCart);
//         if (!Array.isArray(cartArray)) cartArray = [];
//       }
      
//       // Check if item already exists in cart
//       const existingItemIndex = cartArray.findIndex(item => item.id === product.id);
//       let newQuantity = 1;
      
//       if (existingItemIndex >= 0) {
//         // Increment quantity if already in cart
//         newQuantity = (cartArray[existingItemIndex].quantity || 1) + 1;
//         cartArray[existingItemIndex].quantity = newQuantity;
//       } else {
//         // Add new item to cart
//         const cartItem = {
//           id: product.id,
//           name: product.name,
//           price: product.price || 0,
//           quantity: 1,
//           imageUrl: product.imageUrl || product.image,
//           image: product.imageUrl || product.image,
//           deliverySpeed: product.deliverySpeed || 'normal',
//           originalDeliverySpeed: product.deliverySpeed || 'normal'
//         };
        
//         cartArray.push(cartItem);
//         newQuantity = 1;
//       }
      
//       // Update cartItems state to reflect changes
//       setCartItems(prevState => ({
//         ...prevState,
//         [product.id]: newQuantity
//       }));
      
//       // Save updated cart to localStorage
//       localStorage.setItem('cartItems', JSON.stringify(cartArray));
      
//       // Also save to Firestore if user is logged in
//       try {
//         const authToken = localStorage.getItem('authToken');
//         if (authToken) {
//           // Get user info
//           const userInfo = JSON.parse(localStorage.getItem('userData') || '{}');
//           const userId = userInfo.uid;
          
//           if (userId) {
//             // Add to cart history in Firestore
//             await addDoc(collection(db, 'cartHistory'), {
//               userId: userId,
//               productId: product.id,
//               productName: product.name,
//               price: product.price || 0,
//               quantity: 1,
//               addedAt: Timestamp.now(),
//               source: 'compare'
//             });
//           }
//         }
//       } catch (firestoreError) {
//         console.error("Error saving to Firestore:", firestoreError);
//         // Continue execution even if Firestore fails
//       }
      
//       // Dispatch cart updated event
//       const event = new Event('cartUpdated');
//       window.dispatchEvent(event);
      
//       // Show notification
//       setNotification({
//         show: true,
//         message: `${product.name} added to cart (${newQuantity})`,
//         type: 'success'
//       });
      
//       // Hide notification after 3 seconds
//       setTimeout(() => {
//         setNotification({ show: false, message: '', type: '' });
//       }, 3000);
      
//     } catch (error) {
//       console.error("Error adding item to cart:", error);
//       setError("Error adding item to cart. Please try again.");
//     }
//   };

//   const handleUpdateCart = (product, change) => {
//     try {
//       // Get existing cart
//       const existingCart = localStorage.getItem('cartItems');
//       let cartArray = [];
      
//       if (existingCart) {
//         cartArray = JSON.parse(existingCart);
//         if (!Array.isArray(cartArray)) cartArray = [];
//       }
      
//       // Find the item in the cart
//       const existingItemIndex = cartArray.findIndex(item => item.id === product.id);
      
//       if (existingItemIndex >= 0) {
//         const currentQuantity = cartArray[existingItemIndex].quantity || 1;
//         const newQuantity = Math.max(0, currentQuantity + change);
        
//         if (newQuantity === 0) {
//           // Remove item from cart if quantity becomes 0
//           cartArray.splice(existingItemIndex, 1);
          
//           // Update cartItems state
//           setCartItems(prevState => {
//             const newState = { ...prevState };
//             delete newState[product.id];
//             return newState;
//           });
          
//           // Show notification
//           setNotification({
//             show: true,
//             message: `${product.name} removed from cart`,
//             type: 'info'
//           });
//         } else {
//           // Update quantity
//           cartArray[existingItemIndex].quantity = newQuantity;
          
//           // Update cartItems state
//           setCartItems(prevState => ({
//             ...prevState,
//             [product.id]: newQuantity
//           }));
          
//           // Show notification
//           setNotification({
//             show: true,
//             message: `${product.name} quantity updated (${newQuantity})`,
//             type: 'success'
//           });
//         }
        
//         // Save updated cart to localStorage
//         localStorage.setItem('cartItems', JSON.stringify(cartArray));
        
//         // Dispatch cart updated event
//         const event = new Event('cartUpdated');
//         window.dispatchEvent(event);
        
//         // Hide notification after 3 seconds
//         setTimeout(() => {
//           setNotification({ show: false, message: '', type: '' });
//         }, 3000);
//       }
//     } catch (error) {
//       console.error("Error updating cart:", error);
//       setError("Error updating cart. Please try again.");
//     }
//   };

//   const handleClearAll = () => {
//     setCompareItems([]);
//     localStorage.setItem('compareItems', JSON.stringify([]));
    
//     // Dispatch event to update floating action button
//     const event = new Event('compareUpdated');
//     window.dispatchEvent(event);
//   };

//   if (loading) {
//     return (
//       <div className="compare-container">
//         <h1 className="compare-title">PRODUCT COMPARISON</h1>
//         <div className="loading-message">Loading comparison data...</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="compare-container">
//         <h1 className="compare-title">PRODUCT COMPARISON</h1>
//         <div className="error-message">{error}</div>
//       </div>
//     );
//   }

//   if (compareItems.length === 0) {
//     return (
//       <div className="compare-container">
//         <h1 className="compare-title">PRODUCT COMPARISON</h1>
//         <div className="empty-compare">
//           <p>You haven't added any products to compare yet.</p>
//           <Link to="/products" className="browse-products-btn">Browse Products</Link>
//         </div>
//       </div>
//     );
//   }

//   // Dynamically generate attributes based on the first item
//   // This ensures we include all available technical specifications
//   const generateAttributes = () => {
//     const baseAttributes = [
//       { key: 'image', label: 'Image' },
//       { key: 'name', label: 'Name' },
//       { key: 'price', label: 'Price', format: (value) => `₹${parseFloat(value).toFixed(2)}` }
//     ];
    
//     // Technical specifications
//     const techSpecs = [
//       { key: 'model', label: 'Model' },
//       { key: 'microcontroller', label: 'Microcontroller' },
//       { key: 'clockSpeed', label: 'Clock Speed' },
//       { key: 'flashMemory', label: 'Flash Memory' },
//       { key: 'digitalIOPins', label: 'Digital I/O Pins' },
//       { key: 'analogInputPins', label: 'Analog Input Pins' },
//       { key: 'communicationInterfaces', label: 'Communication Interfaces' },
//       { key: 'dimensions', label: 'Dimensions' },
//       { key: 'weight', label: 'Weight' },
//       { key: 'operatingVoltage', label: 'Operating Voltage' },
//       { key: 'operatingTemperature', label: 'Operating Temperature' },
//       { key: 'powerConsumption', label: 'Power Consumption' },
//       { key: 'ledIndicators', label: 'LED Indicators' },
//       { key: 'material', label: 'Material' },
//       { key: 'usbInterface', label: 'USB Interface' },
//       { key: 'warranty', label: 'Warranty' },
//       { key: 'deliverySpeed', label: 'Delivery', format: (value) => {
//         switch(value) {
//           case 'quick': return 'Quick (Same Day)';
//           case 'express': return 'Express (Within Hours)';
//           case 'standard': return 'Standard (2-3 Days)';
//           case 'late': return 'Extended (3-7 Days)';
//           case 'normal':
//           default: return 'Normal (Next Day)';
//         }
//       }}
//     ];
    
//     // Only include tech specs that exist in at least one product
//     const filteredTechSpecs = techSpecs.filter(spec => {
//       return compareItems.some(item => item[spec.key] !== undefined);
//     });
    
//     // Final attributes with description and action buttons
//     const finalAttributes = [
//       ...baseAttributes,
//       ...filteredTechSpecs,
//       { key: 'description', label: 'Description' },
//       { key: 'fullDescription', label: 'Full Description' },
//       { key: 'remove', label: 'Remove' },
//       { key: 'addToCart', label: 'Add to Cart' }
//     ];
    
//     return finalAttributes;
//   };

//   const attributes = generateAttributes();

//   return (
//     <div className="compare-container">
//       {/* Notification */}
//       {notification.show && (
//         <div className={`notification ${notification.type}`}>
//           {notification.message}
//         </div>
//       )}
      
//       <div className="compare-header">
//         <h1 className="compare-title">PRODUCT COMPARISON</h1>
//         {compareItems.length > 0 && (
//           <button className="clear-all-btn" onClick={handleClearAll}>
//             Clear All
//           </button>
//         )}
//       </div>

//       <div className="comparison-table-container">
//         <table className="comparison-table">
//           <tbody>
//             {attributes.map((attr) => (
//               <tr key={attr.key}>
//                 <th>{attr.label}</th>
//                 {compareItems.map((product) => (
//                   <td key={`${product.id}-${attr.key}`}>
//                     {attr.key === 'image' ? (
//                       <div className="product-image-cell">
//                         <img 
//                           src={product.imageUrl || product.image || "/images/product-placeholder.jpg"} 
//                           alt={product.name}
//                           onError={(e) => {
//                             e.target.onerror = null;
//                             e.target.src = "/images/product-placeholder.jpg";
//                           }}
//                         />
//                       </div>
//                     ) : attr.key === 'name' ? (
//                       <div className="product-name-cell">
//                         {product.name}
//                       </div>
//                     ) : attr.key === 'remove' ? (
//                       <button 
//                         className="remove-btn"
//                         onClick={() => handleRemoveItem(product.id)}
//                         aria-label={`Remove ${product.name} from comparison`}
//                       >
//                         ✕
//                       </button>
//                     ) : attr.key === 'addToCart' ? (
//                       <div className="cart-controls-cell">
//                         {cartItems[product.id] ? (
//                           <div className="quantity-control">
//                             <button 
//                               className="quantity-btn decrease"
//                               onClick={() => handleUpdateCart(product, -1)}
//                             >
//                               -
//                             </button>
//                             <span className="quantity-display">
//                               {cartItems[product.id]}
//                             </span>
//                             <button 
//                               className="quantity-btn increase"
//                               onClick={() => handleUpdateCart(product, 1)}
//                             >
//                               +
//                             </button>
//                           </div>
//                         ) : (
//                           <button 
//                             className="add-to-cart-btn"
//                             onClick={() => handleAddToCart(product)}
//                           >
//                             ADD TO CART
//                           </button>
//                         )}
//                       </div>
//                     ) : (
//                       <div className={`product-${attr.key}-cell`}>
//                         {attr.format ? attr.format(product[attr.key] || '-') : (product[attr.key] || '-')}
//                       </div>
//                     )}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default Compare;




import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { collection, addDoc, Timestamp, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import './Compare.css';

const Compare = () => {
  const [compareItems, setCompareItems] = useState([]);
  const [cartItems, setCartItems] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });


  const navigate = useNavigate();


  useEffect(() => {
    const fetchCompareItems = async () => {
      try {
        // Load compare items from localStorage
        const storedItems = localStorage.getItem('compareItems');
        if (storedItems) {
          const parsedItems = JSON.parse(storedItems);
          const itemsArray = Array.isArray(parsedItems) ? parsedItems : [];
          
          // For each item in compare, fetch the complete data from Firestore
          const enrichedItems = await Promise.all(
            itemsArray.map(async (item) => {
              try {
                // If the item already has all required data, return it as is
                if (item.id && item.name && item.price) {
                  return item;
                }
                
                // Otherwise, fetch complete data from Firestore
                const productDoc = await getDoc(doc(db, 'products', item.id));
                
                if (productDoc.exists()) {
                  const productData = productDoc.data();
                  // Merge existing item data with Firestore data
                  return { ...item, ...productData };
                }
                return item;
              } catch (fetchError) {
                console.error(`Error fetching details for product ${item.id}:`, fetchError);
                return item;
              }
            })
          );
          
          setCompareItems(enrichedItems);
          
          // Update localStorage with enriched data
          localStorage.setItem('compareItems', JSON.stringify(enrichedItems));
        } else {
          setCompareItems([]);
        }

        // Load cart items to track which products are already in cart
        const storedCart = localStorage.getItem('cartItems');
        if (storedCart) {
          const parsedCart = JSON.parse(storedCart);
          const cartMap = {};
          
          if (Array.isArray(parsedCart)) {
            parsedCart.forEach(item => {
              cartMap[item.id] = item.quantity || 0;
            });
          }
          
          setCartItems(cartMap);
        }
      } catch (error) {
        console.error("Error loading compare items:", error);
        setError("Error loading comparison items. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchCompareItems();

    // Listen for cart updates
    const handleCartUpdate = () => {
      const storedCart = localStorage.getItem('cartItems');
      if (storedCart) {
        const parsedCart = JSON.parse(storedCart);
        const cartMap = {};
        
        if (Array.isArray(parsedCart)) {
          parsedCart.forEach(item => {
            cartMap[item.id] = item.quantity || 0;
          });
        }
        
        setCartItems(cartMap);
      } else {
        setCartItems({});
      }
    };

    window.addEventListener('cartUpdated', handleCartUpdate);
    
    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, []);

  const handleRemoveItem = (productId) => {
    try {
      const updatedItems = compareItems.filter(item => item.id !== productId);
      setCompareItems(updatedItems);
      localStorage.setItem('compareItems', JSON.stringify(updatedItems));
      
      // Dispatch event to update floating action button
      const event = new Event('compareUpdated');
      window.dispatchEvent(event);
    } catch (error) {
      console.error("Error removing item from compare:", error);
      setError("Error removing item. Please try again.");
    }
  };

  const handleAddToCart = async (product) => {
    try {
      // Get existing cart
      const existingCart = localStorage.getItem('cartItems');
      let cartArray = [];
      
      if (existingCart) {
        cartArray = JSON.parse(existingCart);
        if (!Array.isArray(cartArray)) cartArray = [];
      }
      
      // Check if item already exists in cart
      const existingItemIndex = cartArray.findIndex(item => item.id === product.id);
      let newQuantity = 1;
      
      if (existingItemIndex >= 0) {
        // Increment quantity if already in cart
        newQuantity = (cartArray[existingItemIndex].quantity || 1) + 1;
        cartArray[existingItemIndex].quantity = newQuantity;
      } else {
        // Add new item to cart
        const cartItem = {
          id: product.id,
          name: product.name,
          price: product.price || 0,
          quantity: 1,
          imageUrl: product.imageUrl || product.image,
          image: product.imageUrl || product.image,
          deliverySpeed: product.deliverySpeed || 'normal',
          originalDeliverySpeed: product.deliverySpeed || 'normal'
        };
        
        cartArray.push(cartItem);
        newQuantity = 1;
      }
      
      // Update cartItems state to reflect changes
      setCartItems(prevState => ({
        ...prevState,
        [product.id]: newQuantity
      }));
      
      // Save updated cart to localStorage
      localStorage.setItem('cartItems', JSON.stringify(cartArray));
      
      // Also save to Firestore if user is logged in
      try {
        const authToken = localStorage.getItem('authToken');
        if (authToken) {
          // Get user info
          const userInfo = JSON.parse(localStorage.getItem('userData') || '{}');
          const userId = userInfo.uid;
          
          if (userId) {
            // Add to cart history in Firestore
            await addDoc(collection(db, 'cartHistory'), {
              userId: userId,
              productId: product.id,
              productName: product.name,
              price: product.price || 0,
              quantity: 1,
              addedAt: Timestamp.now(),
              source: 'compare'
            });
          }
        }
      } catch (firestoreError) {
        console.error("Error saving to Firestore:", firestoreError);
        // Continue execution even if Firestore fails
      }
      
      // Dispatch cart updated event
      const event = new Event('cartUpdated');
      window.dispatchEvent(event);
      
      // Show notification
      setNotification({
        show: true,
        message: `${product.name} added to cart (${newQuantity})`,
        type: 'success'
      });
      
      // Hide notification after 3 seconds
      setTimeout(() => {
        setNotification({ show: false, message: '', type: '' });
      }, 3000);
      
    } catch (error) {
      console.error("Error adding item to cart:", error);
      setError("Error adding item to cart. Please try again.");
    }
  };

  const handleUpdateCart = (product, change) => {
    try {
      // Get existing cart
      const existingCart = localStorage.getItem('cartItems');
      let cartArray = [];
      
      if (existingCart) {
        cartArray = JSON.parse(existingCart);
        if (!Array.isArray(cartArray)) cartArray = [];
      }
      
      // Find the item in the cart
      const existingItemIndex = cartArray.findIndex(item => item.id === product.id);
      
      if (existingItemIndex >= 0) {
        const currentQuantity = cartArray[existingItemIndex].quantity || 1;
        const newQuantity = Math.max(0, currentQuantity + change);
        
        if (newQuantity === 0) {
          // Remove item from cart if quantity becomes 0
          cartArray.splice(existingItemIndex, 1);
          
          // Update cartItems state
          setCartItems(prevState => {
            const newState = { ...prevState };
            delete newState[product.id];
            return newState;
          });
          
          // Show notification
          setNotification({
            show: true,
            message: `${product.name} removed from cart`,
            type: 'info'
          });
        } else {
          // Update quantity
          cartArray[existingItemIndex].quantity = newQuantity;
          
          // Update cartItems state
          setCartItems(prevState => ({
            ...prevState,
            [product.id]: newQuantity
          }));
          
          // Show notification
          setNotification({
            show: true,
            message: `${product.name} quantity updated (${newQuantity})`,
            type: 'success'
          });
        }
        
        // Save updated cart to localStorage
        localStorage.setItem('cartItems', JSON.stringify(cartArray));
        
        // Dispatch cart updated event
        const event = new Event('cartUpdated');
        window.dispatchEvent(event);
        
        // Hide notification after 3 seconds
        setTimeout(() => {
          setNotification({ show: false, message: '', type: '' });
        }, 3000);
      }
    } catch (error) {
      console.error("Error updating cart:", error);
      setError("Error updating cart. Please try again.");
    }
  };


  const handleGoBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(-1, { replace: true });
  };


  const handleClearAll = () => {
    setCompareItems([]);
    localStorage.setItem('compareItems', JSON.stringify([]));
    
    // Dispatch event to update floating action button
    const event = new Event('compareUpdated');
    window.dispatchEvent(event);
  };

  if (loading) {
    return (
      <div className="compare-container">
        <h1 className="compare-title">PRODUCT COMPARISON</h1>
        <div className="loading-message">Loading comparison data...</div>
      </div>
    );
  }


  if (error) {
    return (
      <div className="compare-container">
        <h1 className="compare-title">PRODUCT COMPARISON</h1>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (compareItems.length === 0) {
    return (
      <div className="compare-container">
        <h1 className="compare-title">PRODUCT COMPARISON</h1>
        <div className="empty-compare">
          <p>You haven't added any products to compare yet.</p>
          <Link to="/products" className="browse-products-btn">Browse Products</Link>
        </div>
      </div>
    );
  }

  // Generate base attributes that are always shown
  const getBaseAttributes = () => {
    return [
      { key: 'image', label: 'Image' },
      { key: 'name', label: 'Name' },
      { key: 'price', label: 'Price', format: (value) => `₹${parseFloat(value).toFixed(2)}` }
    ];
  };

  // Generate common specifications that may be present in different products
  const getCommonSpecifications = () => {
    const specs = [
      // { key: 'model', label: 'Model' },
      { key: 'material', label: 'Material' },
      { key: 'dimensions', label: 'Dimensions' },
      { key: 'weight', label: 'Weight' },
      { key: 'warranty', label: 'Warranty' },
      { key: 'deliverySpeed', label: 'Delivery', format: (value) => {
        switch(value) {
          case 'quick': return 'Quick (Same Day)';
          case 'express': return 'Express (Within Hours)';
          case 'standard': return 'Standard (2-3 Days)';
          case 'late': return 'Extended (3-7 Days)';
          case 'normal':
          default: return 'Normal (Next Day)';
        }
      }}
    ];
    
    // Only include specs that exist in at least one product
    return specs.filter(spec => 
      compareItems.some(item => item[spec.key] !== undefined && item[spec.key] !== null)
    );
  };
  
  // Generate technical specifications that may be present in electronic products
  const getTechnicalSpecifications = () => {
    const techSpecs = [
      { key: 'microcontroller', label: 'Microcontroller' },
      { key: 'clockSpeed', label: 'Clock Speed' },
      { key: 'flashMemory', label: 'Flash Memory' },
      { key: 'digitalIOPins', label: 'Digital I/O Pins' },
      { key: 'analogInputPins', label: 'Analog Input Pins' },
      { key: 'pwmChannels', label: 'PWM Channels' },
      { key: 'communicationInterfaces', label: 'Communication Interfaces' },
      { key: 'operatingVoltage', label: 'Operating Voltage' },
      { key: 'inputVoltageRecommended', label: 'Input Voltage (Recommended)' },
      { key: 'inputVoltageLimits', label: 'Input Voltage (Limits)' },
      { key: 'sram', label: 'SRAM' },
      { key: 'eeprom', label: 'EEPROM' },
      { key: 'operatingTemperature', label: 'Operating Temperature' },
      { key: 'powerConsumption', label: 'Power Consumption' },
      { key: 'ledIndicators', label: 'LED Indicators' },
      { key: 'usbInterface', label: 'USB Interface' }
    ];
    
    // Only include tech specs that exist in at least one product
    return techSpecs.filter(spec => 
      compareItems.some(item => item[spec.key] !== undefined && item[spec.key] !== null && item[spec.key] !== '-')
    );
  };
  
  // Collect and generate all custom specifications from all products
  const getCustomSpecifications = () => {
    const customSpecs = [];
    
    // Collect all unique custom specifications
    compareItems.forEach(item => {
      if (item.customSpecifications && Array.isArray(item.customSpecifications)) {
        item.customSpecifications.forEach(spec => {
          // Check if this spec is already in our array
          const existingSpec = customSpecs.find(s => s.label === spec.title);
          if (!existingSpec) {
            customSpecs.push({
              key: `custom_${spec.title.replace(/\s+/g, '_').toLowerCase()}`,
              label: spec.title,
              isCustom: true
            });
          }
        });
      }
    });
    
    return customSpecs;
  };

  // Generate description and action attributes
  const getDescriptionAndActionAttributes = () => {
    return [
      { key: 'description', label: 'Description' },
      // { key: 'fullDescription', label: 'Full Description' },
      { key: 'remove', label: 'Remove' },
      { key: 'addToCart', label: 'Add to Cart' }
    ];
  };
  
  // Get custom specification value for a product
  const getCustomSpecValue = (product, specLabel) => {
    if (!product.customSpecifications || !Array.isArray(product.customSpecifications)) {
      return '-';
    }
    
    const spec = product.customSpecifications.find(s => s.title === specLabel);
    return spec ? spec.value : '-';
  };

  // Combine all attributes
  const generateAttributes = () => {
    const baseAttributes = getBaseAttributes();
    const commonSpecs = getCommonSpecifications();
    const techSpecs = getTechnicalSpecifications();
    const customSpecs = getCustomSpecifications();
    const descriptionAndActions = getDescriptionAndActionAttributes();
    
    return [
      ...baseAttributes,
      ...commonSpecs,
      ...techSpecs,
      ...customSpecs,
      ...descriptionAndActions
    ];
  };

  const attributes = generateAttributes();

  return (
    <div className="compare-container">

      <button className="go-back-btn2" onClick={handleGoBack}>
        ← Go Back
      </button>
      {/* Notification */}
      {notification.show && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}
      
      <div className="compare-header">
        <h1 className="compare-title">PRODUCT COMPARISON</h1>
        {compareItems.length > 0 && (
          <button className="clear-all-btn" onClick={handleClearAll}>
            Clear All
          </button>
        )}
      </div>

      <div className="comparison-table-container">
        <table className="comparison-table">
          <tbody>
            {attributes.map((attr) => (
              <tr key={attr.key}>
                <th>{attr.label}</th>
                {compareItems.map((product) => (
                  <td key={`${product.id}-${attr.key}`}>
                    {attr.key === 'image' ? (
                      <div className="product-image-cell">
                        <img 
                          src={product.imageUrl || product.image || "/images/product-placeholder.jpg"} 
                          alt={product.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/images/product-placeholder.jpg";
                          }}
                        />
                      </div>
                    ) : attr.key === 'name' ? (
                      <div className="product-name-cell">
                        {product.name}
                      </div>
                    ) : attr.key === 'remove' ? (
                      <button 
                        className="remove-btn"
                        onClick={() => handleRemoveItem(product.id)}
                        aria-label={`Remove ${product.name} from comparison`}
                      >
                        ✕
                      </button>
                    ) : attr.key === 'addToCart' ? (
                      <div className="cart-controls-cell">
                        {cartItems[product.id] ? (
                          <div className="quantity-control">
                            <button 
                              className="quantity-btn decrease"
                              onClick={() => handleUpdateCart(product, -1)}
                            >
                              -
                            </button>
                            <span className="quantity-display">
                              {cartItems[product.id]}
                            </span>
                            <button 
                              className="quantity-btn increase"
                              onClick={() => handleUpdateCart(product, 1)}
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <button 
                            className="add-to-cart-btn"
                            onClick={() => handleAddToCart(product)}
                          >
                            ADD TO CART
                          </button>
                        )}
                      </div>
                    ) : attr.isCustom ? (
                      // Handle custom specifications
                      <div className={`product-spec-cell`}>
                        {getCustomSpecValue(product, attr.label) || '-'}
                      </div>
                    ) : (
                      // Handle regular specifications
                      <div className={`product-${attr.key}-cell`}>
                        {attr.format ? attr.format(product[attr.key] || '-') : (product[attr.key] || '-')}
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Compare;